import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';

import { createEvent } from './createEvent.builder';
import { deleteEvent } from './deleteEvent.builder';
import { EventsState, StatysType } from './events.interface';
import { getAllEventsBuilder } from './getAllEvents.builder';
import { getEventById } from './getEventById.builder';
import { getAllEventsTypeBuilder } from './getEventTypeList.builder';
import { updateEvent } from './updateEvent.builder';

const initialState: EventsState = {
  status: 'RESTORING' as StatysType,
  events: undefined,
  eventDetail: undefined,
  eventTypeList: undefined,
  errorDetails: undefined,
};

export const eventsSlice = createSlice({
  initialState,
  name: 'events',
  reducers: {
    clearEventDetail: state => {
      state.eventDetail = undefined;
    },
    newEvent: state => {
      state.eventDetail = {
        identifier: uuid(),
        name: '',
        description: '',
        eventTypeId: undefined,
        description_pt: '',
        description_es: '',
        description_en: '',
      };
    },
  },
  extraReducers(builder) {
    getAllEventsBuilder(builder);
    getAllEventsTypeBuilder(builder);
    getEventById(builder);
    createEvent(builder);
    updateEvent(builder);
    deleteEvent(builder);
  },
});
export const { clearEventDetail, newEvent } = eventsSlice.actions;
